import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import "./Header.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();
  let loggedUsername = localStorage.getItem("username");
  let token = localStorage.getItem("token");
  // let balance = localStorage.getItem("balance");

  const _handleLogout = () => {
    localStorage.clear();
    history.push("/");
    // window.location.reload()
  };

  // console.log("login", login);
  // console.log(children); //undefined
  // console.log(hasHiddenAuthButtons); //true
  // fetch user info from local storage
  // if user data is present => someone has logged in render button acc.
  // if user data is NOT present => someone has logged in render button acc.

  // *  hasHiddenAuthButtons -> true ==>seeing register / login page => we need back to explore
  // * product page a) user loggedIn => logout button
  // * product page b)no user loggedIn =>login / register button

  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
    
    {children}

      <Stack direction="row" spacing={2}>
        {hasHiddenAuthButtons ? (
          <Button
            className="explore-button"
            startIcon={<ArrowBackIcon />}
            variant="text"
            onClick={() => history.push("/")}
          >
            Back to explore
          </Button>
        ) : token ? (
          <div className="logout_div">
            <div className="avatar_div">
              <Avatar alt={loggedUsername} src="../../public/avatar.png" />
              <p>{loggedUsername}</p>
            </div>

            <Button variant="text" onClick={() => _handleLogout()}>
              LOGOUT
            </Button>
          </div>
        ) : (
          <div>
            <Button variant="text" onClick={() => history.push("/login")}>
              LOGIN
            </Button>
            <Button
              variant="contained"
              onClick={() => history.push("/register")}
            >
              REGISTER
            </Button>
          </div>
        )}
      </Stack>
    </Box>
  );
};

export default Header;
